import { useEffect, useState, useRef, useCallback } from "react";
import { apiClient } from "../../lib/api";
import { formatDateCheckInOut, formatDateToTime, getDayOfTheWeek } from "../../lib/dateUtils";
import { useAppStore } from "../../store/useAppStore";

const Mensajeria = () => {
  // useState
  const [messages, setMessages] = useState<any[]>([]);
  // const [bookData, setBookData] = useState<any>(null);
  const [messageSend, setMessageSend] = useState("");
  const [conversation, setConversation] = useState<any[]>([]);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [parametricIncidentTypes, setParametricIncidentTypes] = useState<any[]>([]);
  const [parametricIncidentResponsibles, setParametricIncidentResponsibles] = useState<any[]>([]);
  const [selectedConversation, setSelectedConversation] = useState<any>(null);
  const [detailsView, setDetailsView] = useState("");
  const [incidentType, setIncidentType] = useState<any>(null);
  const [responsible, setResponsible] = useState<any>(null);
  const [allowsRefund, setAllowsRefund] = useState<boolean>(false);
  const [appliesPenalty, setAppliesPenalty] = useState<boolean>(false);
  const [previewFinancialApplication, setPreviewFinancialApplication] = useState<any>(null);
  const [isLoadingDetails, setIsLoadingDetails] = useState(false);
  const [isLoadingConversations, setIsLoadingConversations] = useState(true);

  // store
  const addNotification = useAppStore((state) => state.addNotification);

  // useRef
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // store
  const user = useAppStore((state) => state.user);

  // Función para hacer scroll al final
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // functions
  async function openChat(conv: any) {
    setSelectedConversation(conv);
    setIsLoadingDetails(true);
    if (window.innerWidth < 1024) {
      document.querySelector(".list-view")?.classList.add("hidden");
      document.querySelector(".chat-view")?.classList.add("active");
    }
    try {
      const response: any = await apiClient.get(
        `Messaging/Conversations/${conv.conversationId}/Messages?orderBy=dateAsc`,
      );
      if (response.statusCode == "200" && response.data) {
        setMessages(response?.data);
        console.log("Mensajes de la conversación:", selectedConversation);
        if (conv?.tbComplaints?.length != undefined && conv?.tbComplaints?.length > 0) {
          setDetailsView("incidentType");
          setIncidentType(null);
          setResponsible(null);
          setAllowsRefund(false);
          setAppliesPenalty(false);
          setPreviewFinancialApplication(null);
        } else {
          setDetailsView("chat_1");
        }
      }
    } catch (error) {
      console.error("Error fetching conversation details:", error);
    } finally {
      setIsLoadingDetails(false);
    }

    try {
      const response: any = await apiClient.get(`GetProfileByUserId/${conv?.userIdOneNavigation?.userId}`);
      if (response.statusCode === "200" && response.data) {
        setUserProfile(response.data);
      }
    } catch (error: any) {
      console.error("Error fetching conversation details:", error);
    }

    /*try {
      const response: any = await apiClient.get(`Book/${conv?.booking?.bookId}`);
      if (response.statusCode === "200" && response.data) {
        setBookData(response.data);
      } else {
        // showSnackbar(responseData.resultError?.message || 'Error al obtener mensajes', 'error');
      }
    } catch (error: any) {
      console.error("Error fetching book data:", error);
    }*/
  }

  const reFetchMessages = async () => {
    if (!selectedConversation?.conversationId) return;

    try {
      const response: any = await apiClient.get(
        `Messaging/Conversations/${selectedConversation.conversationId}/Messages?orderBy=dateAsc`
      );

      if (response.statusCode === "200" && response.data) {
        setMessages(response.data);
      } else {
        // showSnackbar(responseData.resultError?.message || 'Error al obtener mensajes', 'error');
      }
    } catch (error: any) {
      console.error("Error fetching messages:", error);
    }
  };


  const handleSendMessage = async () => {
    try {
      const response: any = await apiClient.post(
        `Messaging/Conversations/${selectedConversation?.conversationId}/Messages`,
        {
          bookId: selectedConversation?.bookId ?? 0,
          messageTypeId: 1,
          body: messageSend,
        },
      );
      if (response.statusCode === "200" && response.data) {
        reFetchMessages();
        setMessageSend("");
      }
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  function closeChat() {
    if (window.innerWidth < 1024) {
      document.querySelector(".chat-view")?.classList.remove("active");
      document.querySelector(".list-view")?.classList.remove("hidden");
    }
  }

  function toggleDetails() {
    if (window.innerWidth < 1024) {
      document.querySelector(".details-panel")?.classList.add("active");
    }
  }

  function closeDetails() {
    document.querySelector(".details-panel")?.classList.remove("active");
  }

  // Función para obtener mensajes sin caché
  const fetchMessages = async () => {
    // if (!conversation?.conversationId) return;
    setIsLoadingConversations(true);

    try {
      const response: any = await apiClient.get(`Messaging/Conversations`);
      if (response.statusCode === "200" && response.data) {
        setConversation(response?.data);
      } else {
        console.error("Error fetching messages:", response);
        // showSnackbar(responseData.resultError?.message || 'Error al obtener mensajes', 'error');
      }
    } catch (error: any) {
      console.error("Error fetching messages:", error);
      // showSnackbar(error?.message || 'Error al cargar mensajes', 'error');
    } finally {
      setIsLoadingConversations(false);
    }
  };

  const handleChangeDetailsView = async (view: string) => {
    if (view === "confirmation1") {
      try {
        const response: any = await apiClient.post(
          `Incident/PreviewFinancialApplication`,
          {
            bookId: selectedConversation?.booking?.bookId ?? 0,
            incidentTypeId: incidentType?.incidentTypeId ?? 0,
            responsibleId: responsible?.responsiblePartyId ?? 0,
            allowsRefund: allowsRefund,
            appliesPenalty: appliesPenalty,
            complaintId: selectedConversation?.tbComplaints?.[0]?.complaintId ?? 0,
          }
        );
        if (response.statusCode === "200" && response.data) {
          setPreviewFinancialApplication(response.data);
          if (response?.data?.previewFinancialCode?.trim() == "9.1") {
            setDetailsView("confirmation1");
          } else if (response?.data?.previewFinancialCode?.trim() == "9.2") {
            setDetailsView("confirmation2");
          } else if (response?.data?.previewFinancialCode?.trim() == "9.3") {
            setDetailsView("confirmation3");
          } else if (response?.data?.previewFinancialCode?.trim() == "9.4") {
            setDetailsView("confirmation4");
          } else if (response?.data?.previewFinancialCode?.trim() == "9.5") {
            setDetailsView("confirmation5");
          } else {
            addNotification({
              type: "error",
              message: "Código de vista de confirmación no reconocido"
            });
          }
        } else {
          addNotification({
            type: "error",
            message: response?.resultError?.message
          });
        }
      } catch (error: any) {
        console.error("Error fetching conversation details:", error);
      }
    } else {
      setDetailsView(view);
    }
  }

  const resolverAndTerminate = async () => {
    try {
      const response: any = await apiClient.post(`Incident/PreviewFinancialApplication`,
        {
          bookId: selectedConversation?.booking?.bookId ?? 0,
          incidentTypeId: incidentType?.incidentTypeId ?? 0,
          responsibleId: responsible?.responsiblePartyId ?? 0,
          allowsRefund: allowsRefund,
          appliesPenalty: appliesPenalty,
          complaintId: selectedConversation?.tbComplaints?.[0]?.complaintId ?? 0,
        });

      if (response.statusCode === "200" && response.data) {
        setDetailsView("end");
        fetchMessages();
        addNotification({
          type: "success",
          message: "Incidente resuelto y terminado exitosamente"
        });
      } else {
        addNotification({
          type: "error",
          message: response?.resultError?.message || "Error al resolver y terminar el incidente"
        });
      }
    } catch (error) {
      console.error("Error al resolver y terminar el incidente:", error);
    }
  }

  const fetchparametrics = useCallback(async () => {
    // Solo cargar si no hay datos en cache
    if (parametricIncidentTypes.length > 0 && parametricIncidentResponsibles.length > 0) {
      return;
    }

    try {
      const params: any = await apiClient.get(`Parametrics/Incident/Types`);
      if (params.statusCode === "200" && params.data) {
        setParametricIncidentTypes(params?.data);
      } else {
        console.error("Error fetching conversations:", params);
      }
    } catch (error) {
      console.error("Error fetching params:", error);
    }
    try {
      const params: any = await apiClient.get(`Parametrics/Incident/Responsibles`);
      if (params.statusCode === "200" && params.data) {
        setParametricIncidentResponsibles(params?.data);
      } else {
        console.error("Error fetching conversations:", params);
      }
    } catch (error) {
      console.error("Error fetching params:", error);
    }
  }, [parametricIncidentTypes.length, parametricIncidentResponsibles.length]);
  //  hooks
  useEffect(() => {
    fetchMessages();
    fetchparametrics();
  }, [fetchparametrics]);


  // Scroll al final cuando cambien los mensajes
  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Polling: Recuperar mensajes cada 10 segundos cuando la conversación está activa
  useEffect(() => {

    const intervalId = setInterval(() => {
      reFetchMessages();
    }, 10000); // 10 segundos

    return () => clearInterval(intervalId);
  }, [reFetchMessages]);


  return (
    <div className="h-full -m-8 lg:-m-6 rounded-card overflow-hidden">
      <main className="flex-1 w-full lg:max-w-full lg:mx-auto lg:px-1">
        <div className="flex h-[calc(100vh-56px)] md:h-[calc(100vh-144px)] lg:rounded-card overflow-hidden lg:border lg:border-neutral-border">
          <aside className="list-view w-full lg:w-[400px] bg-white shadow-sm flex flex-col overflow-hidden flex-shrink-0 lg:border-l lg:border-r border-neutral-border">
            <div className="h-14 md:h-20 px-4 md:px-8 border-b border-neutral-border flex items-center justify-between gap-3">
              <h2 className="text-[16px] md:text-[18px] font-semibold text-neutral-text">
                Mensajes
              </h2>
              <div className="flex items-center gap-1">
                <button className="p-2 hover:bg-neutral-bg rounded-full transition-colors active:scale-90">
                  <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                    search
                  </span>
                </button>
                <button className="p-2 hover:bg-neutral-bg rounded-full transition-colors active:scale-90">
                  <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                    settings
                  </span>
                </button>
              </div>
            </div>
            <div className="px-4 md:px-6 py-3 md:py-4 border-b border-neutral-border">
              <div className="flex gap-2 md:gap-3">
                <button className="px-4 py-2 bg-primary text-white font-medium rounded-full text-[13px] md:text-[14px] hover:bg-ui-primary-hover transition-colors active:scale-95">
                  Todos
                </button>
                <button className="px-4 py-2 text-neutral-text font-medium rounded-full text-[13px] md:text-[14px] hover:bg-neutral-bg transition-colors active:scale-95">
                  No leído
                </button>
              </div>
            </div>
            {/* ini sidebarconversaciones */}
            <div className="flex-1 overflow-y-auto">
              {isLoadingConversations ? (
                <div className="flex flex-col">
                  {[...Array(8)].map((_, index) => (
                    <div key={index} className="px-4 md:px-6 py-4 flex gap-3 md:gap-4 animate-pulse">
                      <div className="size-12 md:size-14 rounded-full bg-gray-200 shrink-0"></div>
                      <div className="flex-1 min-w-0 space-y-2">
                        <div className="flex justify-between items-start">
                          <div className="h-4 bg-gray-200 rounded w-32"></div>
                          <div className="h-3 bg-gray-200 rounded w-16"></div>
                        </div>
                        <div className="h-3 bg-gray-200 rounded w-3/4"></div>
                        <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                Array.isArray(conversation) &&
                conversation.map((conv: any) => {
                  // if (Array.isArray(conv?.tbComplaints) && conv?.tbComplaints?.length > 0) {
                  return (
                    <div
                      key={conv.conversationId}
                      onClick={() => openChat(conv)}
                      className={`px-4 md:px-6 py-4 flex gap-3 md:gap-4 cursor-pointer border-l-4 transition-colors ${selectedConversation?.conversationId ===
                        conv.conversationId
                        ? "border-primary bg-[rgb(243,244,246)]"
                        : "border-transparent hover:bg-neutral-bg"
                        }`}
                    >
                      <div
                        className="size-12 md:size-14 rounded-full bg-cover bg-center shrink-0 ring-2 ring-white"
                        style={{
                          backgroundImage: `url('${user?.id == conv?.userIdOne ? conv?.userIdTwoNavigation?.photoLink : conv?.userIdOneNavigation?.photoLink}')`,
                        }}
                      ></div>
                      <div className="flex-1 min-w-0">
                        {conv?.tbComplaints?.length > 0 && (
                          <p className="text-[14px] text-neutral-text font-medium truncate mb-0.5">
                            {conv?.tbComplaints[0]?.complainCode ?? ""}
                          </p>
                        )}
                        <div className="flex justify-between items-start mb-1">
                          <span className="text-[14px] font-semibold text-neutral-text truncate">
                            {user?.id == conv?.userIdOne
                              ? conv?.userIdTwoNavigation?.name
                              : conv?.userIdOneNavigation?.name}
                          </span>
                          <span className="text-[12px] text-neutral-secondary">
                            {getDayOfTheWeek(conv?.creationDate)}
                          </span>
                        </div>
                        <p className="text-[14px] text-neutral-text font-medium truncate mb-0.5">
                          {conv?.tmMessages[0]?.body ?? ""}
                        </p>
                        <p className="text-[12px] text-neutral-secondary truncate">
                          {/* {getDayOfTheWeek(conv?.creationDate)} */}

                        </p>
                      </div>
                    </div>
                  )
                  // }
                })
              )}
            </div>
            {/* end sidebar conversaciones  */}
          </aside>
          {/* ini mensajes */}
          <section className="chat-view flex-1 bg-white flex-col overflow-hidden">
            <header className="h-20 md:h-28 px-4 md:px-8 border-b border-neutral-border flex items-center justify-between flex-shrink-0">
              <div className="flex items-center gap-3 md:gap-4">
                <button
                  onClick={closeChat}
                  className="w-9 h-9 flex items-center justify-center lg:hidden active:scale-90 transition-transform"
                >
                  <span className="material-symbols-outlined text-jom-gray-900">
                    arrow_back
                  </span>
                </button>
                <div className="size-14 md:size-16 rounded-full bg-neutral-bg flex items-center justify-center overflow-hidden">
                  <img
                    className="size-full object-cover"
                    src={
                      user?.id == selectedConversation?.userIdOne
                        ? selectedConversation?.userIdTwoNavigation?.photoLink
                        : selectedConversation?.userIdOneNavigation?.photoLink
                    }
                  />
                </div>
                <div className="flex flex-col">
                  <span className="text-[17px] md:text-[18px] font-semibold text-neutral-text">
                    {user?.id == selectedConversation?.userIdOne
                      ? selectedConversation?.userIdTwoNavigation?.name
                      : selectedConversation?.userIdOneNavigation?.name}
                  </span>
                  <span className="text-[14px] md:text-[15px] text-neutral-secondary">
                    {selectedConversation?.listingRent?.name}
                  </span>
                </div>
              </div>
              <button
                onClick={toggleDetails}
                className="text-[12px] md:text-[13px] font-medium text-neutral-text bg-neutral-bg px-4 md:px-5 py-2 rounded-full hover:bg-neutral-border transition-colors active:scale-95"
              >
                Detalle
              </button>
            </header>
            <div className="flex-1 overflow-y-auto overflow-x-hidden px-4 md:px-8 py-4 md:py-8 flex flex-col gap-4 md:gap-6">
              {messages.length == 0 ? (
                <div className="text-neutral-secondary text-center text-[14px] mt-10">
                  No hay mensajes en esta conversación.
                </div>
              ) : (
                messages.map((msg: any) => {
                  const isMe = msg.userId == user?.id;

                  if (
                    msg?.typeMessageCode == "info" ||
                    msg?.typeMessageCode == "apr"
                  ) {
                    return (
                      <div key={msg?.messageId}>
                        <div className="flex flex-col items-center gap-4 my-6">
                          <div className="text-neutral-secondary text-[14px] px-6 py-3.5 text-center max-w-lg leading-relaxed">
                            {msg.body}
                          </div>
                        </div>
                      </div>
                    );
                  } else if (msg?.typeMessageCode == "com") {
                    if (!isMe) {
                      return (
                        <div
                          className="flex items-end gap-3 bg-[rgb(243,244,246)] px-4 py-3 rounded-[20px] rounded-bl-[4px] max-w-[65%]"
                          key={msg?.messageId}
                        >
                          <div className="flex flex-col gap-1 max-w-[65%]">
                            <span className="text-[12px] font-medium text-neutral-secondary px-2">
                              {selectedConversation?.userIdOneNavigation?.name}
                            </span>
                            <div className="bg-neutral-bg text-neutral-text px-4 py-3 rounded-[20px] rounded-bl-[4px] text-[14px] leading-relaxed">
                              {msg.body}
                            </div>
                            <span className="text-[12px] text-neutral-secondary px-2">
                              {formatDateToTime(msg.creationDate)}
                            </span>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="self-end flex flex-col gap-1 max-w-[65%] items-end">
                          <span className="text-[12px] font-medium text-neutral-secondary px-2">
                            Tú
                          </span>
                          <div className="bg-primary text-white px-4 py-3 rounded-[20px] rounded-br-[4px] text-[14px] leading-relaxed">
                            {msg.body}
                          </div>
                          <span className="text-[12px] text-neutral-secondary px-2">
                            {formatDateToTime(msg.creationDate)}
                          </span>
                        </div>
                      );
                    }
                  }
                })
              )}
              <div ref={messagesEndRef} />
            </div>
            <footer className="px-4 md:px-8 py-4 md:py-6 bg-white flex-shrink-0 border-t border-neutral-border">
              <div className="relative flex items-center gap-3">
                <input
                  className="w-full h-11 md:h-12 px-4 md:px-5 pr-14 bg-white border border-neutral-border rounded-full focus:outline-none focus:border-primary text-[14px] text-neutral-text placeholder:text-neutral-secondary"
                  placeholder="Escribe un mensaje..."
                  type="text"
                  value={messageSend}
                  onChange={(e) => setMessageSend(e.target.value)}
                  onKeyDown={handleKeyPress}
                />
                <button
                  className="absolute right-3 md:right-4 p-2 hover:bg-neutral-bg rounded-full transition-colors active:scale-90"
                  onClick={handleSendMessage}
                >
                  <span className="material-symbols-outlined text-neutral-secondary text-[22px]">
                    send
                  </span>
                </button>
              </div>
            </footer>
          </section>
          {/* end mensajes */}

          {/* ini detalles de la reserva */}
          <aside className="details-panel fixed lg:relative top-0 right-0 bottom-0 lg:top-auto lg:right-auto lg:bottom-auto w-full lg:w-[400px] bg-white shadow-lg lg:shadow-sm flex-col overflow-hidden flex-shrink-0 border-l border-neutral-border z-50 lg:z-auto flex">
            {detailsView === "incidentType" && (
              <div className="h-20 px-4 lg:px-8 border-b border-neutral-border flex items-center justify-between">
                <button
                  onClick={closeDetails}
                  className="lg:hidden w-9 h-9 flex items-center justify-center active:scale-90 transition-transform"
                >
                  <span className="material-symbols-outlined text-jom-gray-900">
                    close
                  </span>
                </button>

                <h3 className="text-[18px] font-semibold text-neutral-text">
                  Acciones sobre el incidente
                </h3>

                <div className="w-9 lg:hidden"></div>

              </div>
            )}
            <div className="p-6 overflow-y-auto flex-1">
              {isLoadingDetails ? (
                <div className="flex flex-col gap-4 animate-pulse">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="space-y-3">
                    <div className="h-10 bg-gray-200 rounded"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                  </div>
                  <div className="h-24 bg-gray-200 rounded"></div>
                  <div className="h-10 bg-gray-200 rounded"></div>
                </div>
              ) : (
                <>
                  {detailsView === "incidentType" && (
                    <div className="flex flex-col gap-4">
                      {/* <h4 className="text-base font-semibold text-neutral-text">
                  Acciones sobre el incidente
                </h4> */}
                      <div>
                        <p className="text-sm font-medium text-neutral-text mb-2">
                          Tipo de incidente:
                        </p>
                        <div className="flex flex-col gap-2">
                          {parametricIncidentTypes.map((option) => (
                            <label
                              key={option?.incidentTypeId}
                              className="flex items-center gap-2"
                            >
                              <input
                                type="radio"
                                name="incidentType"
                                onChange={() => setIncidentType(option)}
                                className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                              />
                              <span className="text-sm text-neutral-text">
                                {option?.name}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <textarea
                        className="w-full h-24 px-4 py-2 bg-white border border-neutral-border rounded-md focus:outline-none focus:border-primary text-sm text-neutral-text placeholder:text-neutral-secondary"
                        placeholder="Placeholder"
                        maxLength={500}
                      ></textarea>
                      <div className="flex justify-between items-center text-sm text-neutral-secondary">
                        <span>Please enter a Guide description.</span>
                        <span>0/500</span>
                      </div>
                      <button
                        className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                        onClick={() => handleChangeDetailsView("incidentDetails")}
                      >
                        CONTINUAR
                      </button>
                    </div>
                  )}
                  {detailsView === "incidentDetails" && (
                    <div className="flex flex-col gap-6">
                      <div>
                        <p className="text-sm font-medium text-neutral-text mb-2">
                          Responsable del incidente:
                        </p>
                        <div className="flex flex-col gap-2">
                          {parametricIncidentResponsibles.map((option) => (
                            <label
                              key={option?.responsiblePartyId}
                              className="flex items-center gap-2"
                            >
                              <input
                                type="radio"
                                name="responsible"
                                onChange={() => setResponsible(option)}
                                className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                              />
                              <span className="text-sm text-neutral-text">
                                {option?.name}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-neutral-text mb-2">
                          El caso permite devolución:
                        </p>
                        <div className="flex flex-col gap-2">
                          {["Si", "No"].map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-2"
                            >
                              <input
                                type="radio"
                                name="refund"
                                value={option}
                                onChange={() => setAllowsRefund(option === "Si")}
                                className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                              />
                              <span className="text-sm text-neutral-text">
                                {option}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-neutral-text mb-2">
                          El caso permite Penalización:
                        </p>
                        <div className="flex flex-col gap-2">
                          {["Si", "No"].map((option) => (
                            <label
                              key={option}
                              className="flex items-center gap-2"
                            >
                              <input
                                type="radio"
                                name="penalty"
                                value={option}
                                onChange={() => setAppliesPenalty(option === "Si")}
                                className="form-radio h-4 w-4 text-primary border-neutral-border focus:ring-primary"
                              />
                              <span className="text-sm text-neutral-text">
                                {option}
                              </span>
                            </label>
                          ))}
                        </div>
                      </div>
                      <button
                        className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                        onClick={() => handleChangeDetailsView("confirmation1")}
                      >
                        CONTINUAR
                      </button>
                    </div>
                  )}
                  {detailsView === "confirmation1" && (
                    <div className="flex flex-col gap-4">
                      <div className="text-sm text-neutral-text space-y-2">
                        <p>
                          <span className="font-semibold">
                            Interrumpe estadia:
                          </span>{" "}
                          Huesped
                        </p>
                        <div className="flex justify-between">
                          <p>
                            <span className="font-semibold">Devolución:</span> {allowsRefund ? "Si" : "No"}
                          </p>
                          <p>
                            <span className="font-semibold">
                              Penalización:
                            </span>{" "}
                            {appliesPenalty ? "Si" : "No"}
                          </p>
                        </div>
                      </div>
                      <div className="border border-neutral-border rounded-lg p-4">
                        <div className="grid grid-cols-2 gap-4 mb-4">
                          <div>
                            <p className="text-xs text-neutral-secondary mb-1">
                              LLEGADA
                            </p>
                            <p className="text-sm font-medium text-neutral-text">
                              {formatDateCheckInOut(previewFinancialApplication?.checkIn)}
                            </p>
                          </div>
                          <div>
                            <p className="text-xs text-neutral-secondary mb-1">
                              SALIDA
                            </p>
                            <p className="text-sm font-medium text-neutral-text">
                              {formatDateCheckInOut(previewFinancialApplication?.checkOut)}
                            </p>
                          </div>
                        </div>
                        <div>
                          <p className="text-xs text-neutral-secondary mb-1">
                            HUÉSPEDES
                          </p>
                          <p className="text-sm font-medium text-neutral-text">
                            {previewFinancialApplication?.guests} viajeros
                          </p>
                        </div>
                      </div>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between">
                          <span className="text-neutral-secondary">
                            Precio por noche (STANDARD)
                          </span>
                          <span className="font-medium text-neutral-text">
                            {previewFinancialApplication?.standardNight} {previewFinancialApplication?.currencyCode}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-neutral-secondary">
                            Precio por noche (WEEKEND)
                          </span>
                          <span className="font-medium text-neutral-text">
                            {previewFinancialApplication?.weekendNight} {previewFinancialApplication?.currencyCode}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-neutral-secondary">
                            Comisión de uso de plataforma
                          </span>
                          <span className="font-medium text-neutral-text">
                            {previewFinancialApplication?.paymentPlatformComission} {previewFinancialApplication?.currencyCode}
                          </span>
                        </div>
                      </div>
                      <div className="flex justify-between font-bold text-base text-neutral-text pt-2 border-t border-neutral-border">
                        <span>Total</span>
                        <span>{previewFinancialApplication?.standardNight + previewFinancialApplication?.weekendNight + previewFinancialApplication?.paymentPlatformComission} {previewFinancialApplication?.currencyCode}</span>
                      </div>
                      <button
                        className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                        onClick={() => resolverAndTerminate()}
                      >
                        CONTINUAR
                      </button>
                    </div>
                  )}
                  {detailsView === "confirmation2" && (
                    <div className="flex flex-col gap-4 text-sm text-neutral-text">
                      <div className="flex justify-between">
                        <p>
                          <span className="font-semibold">
                            interrumpe estadia:
                          </span>{" "}
                          Huésped
                        </p>
                      </div>
                      <div className="flex justify-between">
                        <p>
                          <span className="font-semibold">Devolución:</span> {allowsRefund ? "Si" : "No"}
                        </p>
                        <p>
                          <span className="font-semibold">Penalización:</span>{" "}
                          {appliesPenalty ? "Si" : "No"}
                        </p>
                      </div>
                      <p>
                        <span className="font-semibold">
                          Total días de la reserva:
                        </span>{" "}
                        {previewFinancialApplication?.totalDaysBook}
                      </p>
                      <p>
                        <span className="font-semibold">
                          Total días no ocupados:
                        </span>{" "}
                        {previewFinancialApplication?.unusedDays}
                      </p>
                      <p>
                        <span className="font-semibold">
                          Monto a devolver al huésped:
                        </span>{" "}
                        {previewFinancialApplication?.refundAmount} {previewFinancialApplication?.currencyCode}
                      </p>
                      <p>
                        <span className="font-semibold">
                          Monto de penalización anfitrión:
                        </span>
                        {previewFinancialApplication?.penaltyAmount} {previewFinancialApplication?.currencyCode}
                      </p>
                      <button
                        className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                        onClick={() => resolverAndTerminate()}
                      >
                        CONTINUAR
                      </button>
                    </div>
                  )}
                  {detailsView === "confirmation3" && (
                    <div className="flex flex-col gap-4">
                      <ul className="list-disc list-inside text-sm text-neutral-text space-y-1">
                        <li>No hay devolución</li>
                        <li>No se aplica penalización</li>
                        <li>
                          La reserva puede continuar o terminar anticipadamente
                          sin devolución
                        </li>
                      </ul>
                      <textarea
                        className="w-full h-24 px-4 py-2 bg-white border border-neutral-border rounded-md focus:outline-none focus:border-primary text-sm text-neutral-text placeholder:text-neutral-secondary"
                        placeholder="Placeholder"
                        maxLength={500}
                      ></textarea>
                      <div className="flex justify-between items-center text-sm text-neutral-secondary">
                        <span>Please enter a Guide description.</span>
                        <span>0/500</span>
                      </div>
                      <button
                        className="w-full bg-primary text-white font-medium py-2.5 rounded-md hover:bg-primary-dark transition-colors active:scale-95"
                        onClick={() => resolverAndTerminate()}
                      >
                        CONTINUAR
                      </button>
                    </div>
                  )}
                  {detailsView === "confirmation4" && (
                    <div className="flex flex-col gap-4 text-sm text-neutral-text">
                      <p>
                        <span className="font-semibold">
                          interrumpe estadia:
                        </span>{" "}
                        Anfitrion
                      </p>
                      <div className="flex justify-between">
                        <p>
                          <span className="font-semibold">Devolución:</span> {allowsRefund ? "Si" : "No"}
                        </p>
                        <p>
                          <span className="font-semibold">Penalización:</span>{" "}
                          {appliesPenalty ? "Si" : "No"}
                        </p>
                      </div>
                      <p>
                        <span className="font-semibold">
                          Total días de la reserva:
                        </span>{" "}
                        {previewFinancialApplication?.totalDaysBook}
                      </p>
                      <p>
                        <span className="font-semibold">
                          Total días no ocupados:
                        </span>{" "}
                        {previewFinancialApplication?.unusedDays}
                      </p>
                      <p>
                        <span className="font-semibold">
                          Monto a devolver al huésped:
                        </span>{" "}
                        {previewFinancialApplication?.refundAmount} {previewFinancialApplication?.currencyCode}
                      </p>
                    </div>
                  )}
                  {detailsView == "end" && (
                    <div className="flex flex-col gap-4"></div>
                  )}
                  {detailsView == "chat_1" && (
                    <div className="flex flex-col gap-6">
                      {/* Encabezado con estado */}
                      <div className="flex items-center justify-between">
                        <span className="text-sm text-neutral-text font-medium">
                          Solicitud de reserva:
                        </span>
                        {/* <span className="px-3 py-1 bg-blue-100 text-primary text-xs font-medium rounded-full">
                          En curso
                        </span> */}
                      </div>

                      {/* Nombre y foto del huésped */}
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-neutral-text">
                          {selectedConversation?.userIdOneNavigation?.name} {selectedConversation?.userIdOneNavigation?.lastName}
                        </h3>
                        <div className="size-14 rounded-full bg-neutral-bg overflow-hidden flex-shrink-0">
                          <img
                            src={
                              user?.id == selectedConversation?.userIdOne
                                ? selectedConversation?.userIdTwoNavigation?.photoLink
                                : selectedConversation?.userIdOneNavigation?.photoLink
                            }
                            alt="Perfil"
                            className="size-full object-cover"
                          />
                        </div>
                      </div>

                      {/* Información de la reserva */}
                      <div className="text-sm text-neutral-text space-y-1">
                        <p className="font-medium">{selectedConversation?.listingRent?.name}</p>
                        <p className="text-neutral-secondary">{selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.calculationDetails ?? ""}</p>
                        <p className="text-neutral-secondary">{selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.amount} {selectedConversation?.booking?.payPriceCalculations?.[0]?.priceCalculation?.currencyCode}</p>
                      </div>

                      {/* Acerca de */}
                      <div className="border-t border-neutral-border pt-4">
                        <h4 className="text-base font-semibold text-neutral-text mb-3">
                          Acerca {selectedConversation?.userIdOneNavigation?.name} {selectedConversation?.userIdOneNavigation?.lastName}
                        </h4>
                        <div className="flex flex-col gap-2 text-sm">
                          <p className="text-neutral-text">
                            Valoración de {userProfile?.guestReviewCalification} en {userProfile?.countReviewsGuest} reseñas
                          </p>
                          <p className="text-neutral-text underline cursor-pointer">
                            Identidad verificada
                          </p>
                          <p className="text-neutral-secondary">
                            Se unió a JOM hace {userProfile?.timeInAssert}
                          </p>
                          <p className="text-neutral-secondary">
                            Vive en {userProfile?.city}, Bolivia
                          </p>
                          <p className="text-neutral-secondary">
                            Habla inglés, español y albanés
                          </p>
                          <p className="text-neutral-text underline cursor-pointer font-medium">
                            Muestra el perfil
                          </p>
                        </div>
                      </div>

                      {/* Detalles de la reservación */}
                      <div className="border-t border-neutral-border pt-4">
                        <h4 className="text-base font-semibold text-neutral-text mb-3">
                          Detalles de la reservación
                        </h4>
                        <div className="flex flex-col gap-3 text-sm">
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1">
                              Huéspedes
                            </p>
                            <p className="text-neutral-text">1 adulto</p>
                          </div>
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                              Check-in
                            </p>
                            <p className="text-neutral-text">mié, 3 ene 2024</p>
                          </div>
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                              Check-out
                            </p>
                            <p className="text-neutral-text">mié, 31 ene 2024</p>
                          </div>
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                              Fecha de la reservación
                            </p>
                            <p className="text-neutral-text">mié, 31 ene 2024</p>
                          </div>
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                              Código de confirmación
                            </p>
                            <p className="text-neutral-text">HM4HJN9TAKB</p>
                          </div>
                          <div>
                            <p className="text-neutral-secondary font-semibold mb-1 border-t border-neutral-border pt-3">
                              Política de cancelación
                            </p>
                            <p className="text-neutral-text">Moderada</p>
                          </div>
                        </div>
                      </div>

                      {/* Sección de Pagos */}
                      <div className="border-t border-neutral-border pt-6">
                        {/* Pagado por el huésped */}
                        <div className="mb-6">
                          <h4 className="text-base font-semibold text-neutral-text mb-4">
                            Pagado por el huésped
                          </h4>
                          <div className="space-y-2 text-sm">
                            <div className="flex justify-between">
                              <span className="text-neutral-text">1 noche x 80,00 BOB</span>
                              <span className="text-neutral-text">80,00 BOB</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-neutral-text">Tarifa por servicio al huésped</span>
                              <span className="text-neutral-text">16,00 BOB</span>
                            </div>
                            <div className="flex justify-between font-semibold text-base pt-2 border-t border-neutral-border mt-2">
                              <span className="text-neutral-text">Total (BOB)</span>
                              <span className="text-neutral-text">96,00 BOB</span>
                            </div>
                          </div>
                        </div>

                        {/* Cobro recibido por el anfitrión */}
                        <div className="border-t border-neutral-border pt-4 mb-6">
                          <h4 className="text-base font-semibold text-neutral-text mb-4">
                            Cobro recibido por el anfitrión
                          </h4>
                          <div className="space-y-2 text-sm">
                            <div className="flex justify-between">
                              <span className="text-neutral-text">Tarifa de la habitación por 11 noches</span>
                              <span className="text-neutral-text">80,00 BOB</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-neutral-text">Tarifa por servicio para anfitriones (3,0 %)</span>
                              <span className="text-neutral-text">-3,00 BOB</span>
                            </div>
                            <div className="flex justify-between font-semibold text-base pt-2 border-t border-neutral-border mt-2">
                              <span className="text-neutral-text">Total (BOB)</span>
                              <span className="text-neutral-text">77,00 BOB</span>
                            </div>
                          </div>
                        </div>

                        {/* Historial de transacciones */}
                        <button className="w-full flex items-center gap-2 py-3 border-t border-b border-neutral-border text-neutral-text hover:bg-neutral-bg transition-colors">
                          <span className="material-symbols-outlined text-[20px]">
                            receipt_long
                          </span>
                          <span className="text-sm font-medium">Historial de transacciones</span>
                        </button>

                        {/* Asistencia */}
                        <div className="pt-6">
                          <h4 className="text-base font-semibold text-neutral-text mb-4">
                            Asistencia
                          </h4>

                          {/* Opciones de asistencia */}
                          <div className="flex flex-col">
                            <button className="flex items-center justify-between py-3 text-left hover:bg-neutral-bg transition-colors border-t border-neutral-border">
                              <span className="text-sm text-neutral-text">
                                Denunciar a este huésped
                              </span>
                              <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                                chevron_right
                              </span>
                            </button>
                            <button className="flex items-center justify-between py-3 text-left hover:bg-neutral-bg transition-colors border-t border-b border-neutral-border">
                              <span className="text-sm text-neutral-text">
                                Visita el centro de ayuda
                              </span>
                              <span className="material-symbols-outlined text-neutral-secondary text-[20px]">
                                chevron_right
                              </span>
                            </button>
                          </div>
                        </div>

                        {/* Preguntas frecuentes */}
                        <div className="pt-6">
                          <h4 className="text-base font-semibold text-neutral-text mb-4">
                            Preguntas frecuentes
                          </h4>

                          <div className="space-y-4">
                            {/* Pregunta 1 */}
                            <div className="pb-4 border-b border-neutral-border">
                              <h5 className="text-sm font-medium text-neutral-text mb-2">
                                Imprimir los detalles de cobro y recibos de las reservaciones
                              </h5>
                              <p className="text-xs text-neutral-secondary mb-2">
                                Podrás encontrar recibos individuales cuando accedes a tus reservaciones.
                              </p>
                              <button className="text-xs text-neutral-text underline font-medium">
                                Seguir leyendo
                              </button>
                            </div>

                            {/* Pregunta 2 */}
                            <div className="pb-4 border-b border-neutral-border">
                              <h5 className="text-sm font-medium text-neutral-text mb-2">
                                Reembolsa a tu huésped
                              </h5>
                              <p className="text-xs text-neutral-secondary mb-2">
                                El proceso para que los anfitriones envíen un reembolso a los huéspedes cambió si se gestiona durante la estadía, la experiencia o el servicio, o bien después del check-in...
                              </p>
                              <button className="text-xs text-neutral-text underline font-medium">
                                Seguir leyendo
                              </button>
                            </div>

                            {/* Pregunta 3 */}
                            <div>
                              <h5 className="text-sm font-medium text-neutral-text mb-2">
                                Cuánto tiempo tienes para dejar una reseña
                              </h5>
                              <p className="text-xs text-neutral-secondary mb-2">
                                Después de que termine tu estadía, tendrás un tiempo limitado para escribir una reseña...
                              </p>
                              <button className="text-xs text-neutral-text underline font-medium">
                                Seguir leyendo
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </aside>
          {/* end detalles de la reserva */}
        </div>
      </main>
    </div>
  );
};
export default Mensajeria;
